import fetch from 'auth/FetchInterceptor'
import { AUTH_PREFIX_PATH } from '../configs/AppConfig'

const AuthService = {}

AuthService.login = data => {
  const formData = new FormData()
  formData.append('username', data.username)
  formData.append('password', data.password)

  return fetch({
    url: '/login',
    method: 'post',
    data: formData,
  })
}

AuthService.logout = () => {
  return fetch({
    url: '/logout',
    method: 'post',
  })
}

AuthService.erpLogin = () => {
  return fetch({
    url: `${AUTH_PREFIX_PATH}/erp-login`,
    method: 'post',
  })
}

AuthService.partnerLogin = data => {
  return fetch({
    url: `${AUTH_PREFIX_PATH}/partner-login`,
    method: 'post',
    data,
  })
}

AuthService.selectNoticeList = () => {
  return fetch({
    url: `${AUTH_PREFIX_PATH}/select-notice-list`,
    method: 'post',
    headers: { 'X-Http-Method-Override': 'GET' },
  })
}

AuthService.selectPopupNoticeList = () => {
  return fetch({
    url: `${AUTH_PREFIX_PATH}/select-popup-notice-list`,
    method: 'post',
    headers: { 'X-Http-Method-Override': 'GET' },
  })
}

AuthService.selectLoginImageList = () => {
  return fetch({
    url: `${AUTH_PREFIX_PATH}/select-login-image-list`,
    method: 'post',
    headers: { 'X-Http-Method-Override': 'GET' },
  })
}

// 토큰 연장 서비스
AuthService.extendingLogin = () => {
  return fetch({
    url: `${AUTH_PREFIX_PATH}/access-token`,
    method: 'get',
  })
}

// 로그인 패스워드 변경
AuthService.updateUserChangePasswordPermitAll = data => {
  return fetch({
    url: `${AUTH_PREFIX_PATH}/update-user-change-password-permit-all`,
    method: 'post',
    data: data,
  })
}

// 패스워드 변경
AuthService.updateUserChangePassword = data => {
  return fetch({
    url: `${AUTH_PREFIX_PATH}/update-user-change-password`,
    method: 'post',
    data: data,
  })
}

// 패스워드 초기화
AuthService.updateUserInitPassword = data => {
  return fetch({
    url: `${AUTH_PREFIX_PATH}/update-user-init-password`,
    method: 'post',
    data: data,
  })
}

// 다국어 변경
AuthService.updateLang = data => {
  return fetch({
    url: `${AUTH_PREFIX_PATH}/update-lang`,
    method: 'post',
    data: data,
  })
}

export default AuthService
